<div class="footer-bar fixed bottom-0 z-50 bg-neutral-200 h-8 px-3 flex items-center"
     [class.footer-bar--expanded]="sidebarOpen">
  <p class="text-[0.95rem] text-neutral-900 font-medium">{{ currentYear }} © ATOZ Tax Advisers</p>
</div>
